// extracted by mini-css-extract-plugin
export default {"becomeVendorForm":"style_becomeVendorForm__3WTYI","errorText":"style_errorText__IWm5y","formBtnContainer":"style_formBtnContainer__Lhm5O"};